var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NoDataFound"},[_c('div',{staticStyle:{"text-align":"center","font-size":"14px","font-weight":"600","color":"#e29d5a","padding":"15px"}},[_vm._v("\n        No data available\n    ")])])
}]

export { render, staticRenderFns }